import * as React from 'react';

import SquareImg from '@components/basics/artwork-img';
import MotionOpacity from '@components/motion/motion-opacity';
import DropdownItem from '@components/form/dropdown/dropdown-item';

import { SimpleRelease } from '@common/types/release/simple-release';

import { GenericDropdownBuilder } from '@webapp/controllers/form/dropdown';
import { SquarePlaceholder } from '@webapp/controllers/release/title-input';

interface SelectAssociatedReleaseProps {
  className?: string;
  releases: SimpleRelease[];
  selected?: SimpleRelease;
  onSelect: (release: SimpleRelease | undefined) => void;
}

const DropdownCtrl = GenericDropdownBuilder();

export const SelectAssociatedRelease: React.FC<
  SelectAssociatedReleaseProps
> = ({ className, releases, selected, onSelect }) => {
  const [releaseSelected, setReleaseSelected] = React.useState<
    SimpleRelease | undefined
  >(selected);
  const [filter, setFilter] = React.useState('');

  const handleReleaseSelected = (item?: SimpleRelease) => {
    setReleaseSelected(item);
    setFilter('');
    onSelect(item);
  };

  const handleFilter = (filterValue: string) => {
    setFilter(filterValue.toLowerCase());
  };

  const filteredReleases = (releases || []).filter((item) =>
    item.title.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <MotionOpacity className={className}>
      <DropdownCtrl
        title="Associated Release"
        hasFilter
        filterLabel="Filter Releases"
        onCustomFilter={handleFilter}
        customFilterValue={filter}
        value={releaseSelected?.title}
        decoration={
          releaseSelected ? (
            <SquareImg
              srcImg={releaseSelected.cover.url}
              borderRadius={4}
              size={28}
            />
          ) : (
            <SquarePlaceholder />
          )
        }
      >
        <DropdownItem
          key="undefined"
          onClick={() => handleReleaseSelected(undefined)}
        >
          --
        </DropdownItem>
        {filteredReleases.map((item) => (
          <DropdownItem
            key={item.id}
            decoration={<SquareImg srcImg={item.cover.url} size={28} />}
            onClick={() => handleReleaseSelected(item)}
          >
            {item.title}
          </DropdownItem>
        ))}
      </DropdownCtrl>
    </MotionOpacity>
  );
};

export default SelectAssociatedRelease;
